import { Outlet } from 'react-router-dom';

import { SidebarProvider } from '@/components/ui/sidebar';

import { AppSidebar } from './app-sidebar';

export function Layout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <div className="relative flex flex-1 flex-col overflow-auto">
        <Outlet />
      </div>
    </SidebarProvider>
  );
}
